<template>
  <div id="servisWrapper">
    <div id="tableWrapper">
      <table id="isporuka">
        <thead>
          <tr>
            <th>RED VOŽNJE</th>
            <th>PON</th>
            <th>UTO</th>
            <th>SRI</th>
            <th>ČET</th>
            <th>PET</th>
            <th>SUB</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Andrijevica</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Bar</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Berane</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Bijelo Polje</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Budva</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
          </tr>
          <tr>
            <td>Cetinje</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Danilovgrad</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
          </tr>
          <tr>
            <td>Herceg Novi</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Kolašin</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Kotor</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
          </tr>
          <tr>
            <td>Mojkovac</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Nikšić</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" /></td>
          </tr>
          <tr>
            <td>Petrovac</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Plav</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Pljevlja</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Podgorica</td>
            <td><img src="/img/avto.png" /></td>
            <td><img src="/img/avto.png" /></td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td><img src="/img/avto.png" /></td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td><img src="/img/avto.png" /></td>
          </tr>
          <tr>
            <td>Rožaje</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Tivat</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
          </tr>
          <tr>
            <td>Tuzi</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Ulcinj</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Žabljak</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>Zeta</td>
            <td><img src="/img/avto.png" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
            <td><img src="/img/avto.png" alt="" /></td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
      <br />

      <p>
        <strong>Plan prevoza za novembar 2026</strong> <br />
        NAPOMENA – Kostajnica se vozi sa Herceg Novim <br />
        NAPOMENA – Rožaje, Petnjicu, Plav, Gusinje i Andrijevicu vozimo petnaestodnevno <br />
        NAPOMENA – Ulcinj vozimo ponedjeljkom, srijedom i petkom <br />
        NAPOMENA – Petrovac, Buljaricu i Rijeku Reževiće vozimo samo srijedom <br />
        NAPOMENA – pri kupovini veće količine robe javiti se Darku Đ. za dodatni dogovor (za Petrovac, Buljaricu, Rožaje, Plav, Gusinje i Andrijevicu) <br />
        NAPOMENA – BIOČE vozimo jednom sedmično – srijedom <br />
        NAPOMENA – za sela van gradova i manje iznose računa kupci preuzimaju robu u najbližem gradu, a za veće iznose računa, ako je kupcima hitno, po dogovoru da kontaktiraju dispečere Darka Đukića i Steva Tatara radi dogovora vanredne isporuke <br />

        03.11.2026 vozimo Rijeku Crnojevića, Njeguši <br />
        04.11.2026 vozimo Plav, Gusinje, Andrijevicu <br />
        06.11.2026 vozimo sa Pljevljima – selo Sula i ostala sela u tom pravcu <br />
        06.11.2026 vozimo Verušu, Mateševo – nalozi se vade sa Kolašinom <br />
        06.11.2026 vozimo Kuče – nalozi se vade sa gradom <br />
        07.11.2026 vozimo Plužine, Piperi, Studeno <br />
        09.11.2026 vozimo Virpazar, Crmnica, Ostros <br />
        11.11.2026 vozimo Rožaje (sela Radeta i Biševo), Petnjicu <br />
        13.11.2026 vozimo sa Pljevljima – sela Pavino Polje, Kovren, Tomaševo, Mataruge, Vrulja <br />
        14.11.2026 vozimo Grahovo, Vilusi, Vraćenovići <br />
        17.11.2026 vozimo Rijeku Crnojevića, Njeguši <br />
        18.11.2026 vozimo Plav, Gusinje, Andrijevicu <br />
        20.11.2026 vozimo sa Pljevljima – sela Boljanići, Potkovac, Metaljka <br />
        20.11.2026 vozimo Verušu, Mateševo – nalozi se vade sa Kolašinom <br />
        20.11.2026 vozimo Kuče – nalozi se vade sa gradom <br />
        21.11.2026 vozimo Plužine, Piperi, Studeno <br />
        23.11.2026 vozimo Virpazar, Crmnica, Ostros <br />
        25.11.2026 vozimo Rožaje (selo Bać), Petnjicu <br />
        27.11.2026 vozimo Šavnik, Boan i ostala sela u tom pravcu <br />
        28.11.2026 vozimo Grahovo, Vilusi, Vraćenovići <br />
      </p>
      <br /><br />
      <h2>Ovlašćeni servisni centri po regijama za montažu - INFO KONTAKT:</h2>

      <p>
        &bull; Herceg Novi, Kotor,
        Tivat........................................................063/222-059<br />
        &bull;
        Budva......................................................................................
        069/922-204<br />
        &bull; Nik&scaron;ić, Grahovo,
        Plužine..........................................................067/666-952<br />
        &bull; Pljevlja, Žabljak,
        &Scaron;avnik...........................................................
        063/222-874<br />
        &bull; Kola&scaron;in,
        Mojkovac...................................................................
        069/598-272<br />
        &bull; Berane, Andrijevica, Rožaje, Plav,
        Gusinje............................. 068/350-636<br />
        &bull; Bijelo
        Polje...............................................................................
        068/087-515<br />
        &bull; Bar, Sutomore, Ulcinj,
        Petrovac...............................................069/077-807<br />
        &bull;
        Danilovgrad.............................................................................
        069/232-506
      </p>
    </div>
    <div id="pravilnikWrapper">
      <h2>Informacije</h2>

      <p>
        1. Informacije o isporuci robe: 067/666-400 od 08h -16h <br />
        2. Informacije o uslovima prodaje namještaja, pohvale i primjedbe:
        067/666-150, 067/666-915, 063/222-454 od 08h - 20h <br />
        3. Informacije o montaži robe i prijavi reklamacija: 063/222-454,
        067/666-300 (pločasti material), 067/666-961(tapetarija) od 08h-16h
        <br />
        4. PRIJAVA PRITUŽBI: 063/222-454, u slučaju pritužbe, dovoljno je
        poslati ime i prezime osobe na koju se vodi račun, kao i kratak opis
        problema (poželjno uz fotografiju ili video). Nakon prijema prijave,
        ovlašćena osoba će vas kontaktirati do kraja radnog vremena, ili
        narednog jutra ako je poruka poslata nakon 16h. <br />
        5. Za online trgovinu: Potrošac može jednostrano odustati od trgovine u
        roku od 14 dana od prijema robe bez navođenja razloga. Odustajanje se
        prijavljuje pisanim putem ili emailom na
        nikolina.stojanovic@namos.co.me. U skladu sa odredbama čl. 110–119
        Zakona o zaštiti potrošača Crne Gore, troškove povraćaja robe snosi
        potrošač.
        <a
          href="https://namos.co.me/pdf/Obrazac-jednostrani_raskid_ugovora-2026.pdf"
          target="_blank"
        >
          Obrazac preuzmite &ensp; <strong> ovdje (link) </strong>
        </a>
        <br />
        <br />
      </p>

      <h2>Pravilnik kompanije</h2>
      <p></p>
      <ol>
        <li>
          Prodavac preuzima obavezu besplatnog prevoza i montaže (za iznose
          preko 200EUR) za sve gradove Crne Gori, do adrese dostupne
          transportnom vozilu (ne uključujući nedjelju, državne i vjerske
          praznike), koja se vr&scaron;i najkasnije u roku &ndash; do 72h, od
          momenta prijema robe.<br />
          2. Prodavac NE VR&Scaron;I UNO&Scaron;ENJE ROBE u stan kupca I NE KAČI
          ELEMENTE NA ZID. Za neuklapanje artikala u stambeni prostor
          potro&scaron;ača, prodavac ne snosi odgovornost.<br />
          3. Isporučena, otpakovana ili namontirana roba, kao i roba prodata
          (proknjižena) u prethodnom mjesecu ne može se zamijeniti.<br />
          4. Prodavac se obavezuje da prema uslovima iz ovog ugovora poruči i
          proda robu kupcu, u svemu po specifikaciji koja je sastavni dio
          ugovora.<br />
          5. Za poručenu robu kupac se obavezuje da uplati avans, minimum 50% od
          ukupne vrijednosti naručene robe, nakon čega počinju teći rokovi iz
          člana 6. Preostalih 50% plaća se po prispjeću robe u centralni
          magacin.<br />
          6. Rok za prispjeće robe u centralni magacin prodavca nagla&scaron;en
          je na računu, s tim, &scaron;to se u slučaju nepredviđenih okolnosti:
          smetnji u prevozu, vremenskih nepogoda, zadržavanju na carinskom
          terminalu, ovaj rok može produžiti za jo&scaron; 7 dana.<br />
          7. U slučaju prekoračenja rokova isporuke, iz člana 6. ugovora, kupac
          zadržava pravo na povraćaj avansa ili dodatnim popustom 10%, ili se
          nudi zamjena za drugi artikal, uz odgovarajući popust od strane
          "Dajković Co Namos"<br />
          8. Roba koja se uplaćuje virmanski iskucava se po zvaničnim izvodima i
          isporuka se vr&scaron;i po planu prevoza, nakon izdate fakture.<br />
          <br />
          <br />
          <strong>NAPOMENA:</strong>Po&scaron;tovani kupci, zbog iskrene i
          velike želje da budete ispo&scaron;tovani, firma &ldquo;Dajković Co
          Namos&rsquo;&rsquo; je obezbijedila video nadzor, kako salona tako i
          svih vozila, robe u transportu kao i samu primopredaju robe. Svi
          zaposleni sa kojima komunicirate imaju ID kartice. U slučaju bilo
          kakve sporne situacije, molimo Vas da kontaktirate na&scaron;e službe.
          Ako niste zadovoljni odgovorom, na raspolaganju Vam je e-mail adresa
          generalnog direktora i vlasnika: dajkovic.company@namos.co.me.<br />
          <br />
        </li>
      </ol>
      <p>Usluga montaže:</p>
      <p>
        Firma &ldquo;NAMOS&rdquo; ima servisne centre za montažu
        namje&scaron;taja u svim gradovima Crne Gore i obezbjeđuje BESPLATNU
        montažu za:
      </p>
      <p>
        ✓Kuhinjepoželji i mjeri - SERVISERI UGRADNIH KUHINJA će na osnovu
        potvrđenog projekta besplatno instalirati kuhinju, okačiti elemente,
        urezati i&nbsp; uklopiti ugradnu tehniku (kupljenu u na&scaron;em
        salonu) vodeći računa o Va&scaron;em planu instalacija, zidovima, sve
        osim prikopčavanja vododovodne i elektroinstalacije, &scaron;to
        preporučujemo da urade sertifikovana lica.
      </p>
      <p>✓Sve vrste ormara, regala i garderobera</p>
      <p>✓ Garniture sa relax mehanizmima</p>
      <p>✓Krevete sa električnim mehanizmima i krevete iz premium kolekcije.</p>
      <ul>
        <li>
          Monter je prema rasporedu obavezan doći na adresu NAJKASNIJE do 72h, a
          za vrijeme prazničnih i najavljenih marketing akcija najkasnije do 5
          dana. UKOLIKO roba poručena iz fabrike po posebnoj želji, kasni
          vi&scaron;e od 7 dana, kupac će dobiti 10% dodatnog popusta ili odabir
          namje&scaron;taja po istoj ili do10% većoj vrijednosti iz asortimana.
        </li>
      </ul>
      <p>
        TRANSPORT ZA KOMADNI NAMJE&Scaron;TAJ U IZNOSU DO 200 EUR, KUPAC SAM
        ORGANIZUJE IZ LOGISTIČKOG CENTRA ILI IZ SALONA PO SISTEMU CASH&amp;CARRY
        (PLATI I NOSI) A ISTI JE FABRIČKI PRIPREMLJEN TAKO DA KUPAC MOŽE SAM DA
        MONTIRA.
      </p>
      <p>&nbsp;</p>
      <p>GARANCIJA</p>
      <p>Garancija nakupljeni namje&scaron;taj je 2 godine .</p>
      <ul>
        <li>
          Eventualna nepravilnost artikla kupljenog kod nas za servisere NAMOS-a
          imaprioritet a rje&scaron;enja su najče&scaron;će omogućena u roku od
          72h,
        </li>
      </ul>
      <p>
        Do prve fabričke isporuke il inajkasnije u zakonom predvidjenim
        rokovima.
      </p>
      <ul>
        <li>
          U slučaju fizičkog ostećenja (VEOMA JE VAŽNO da kupac navede tačnu
          informaciju/česte situacije koje dovode do o&scaron;tećenja
          namje&scaron;taja kao &scaron;to su slučajevi u kojima gosti u
          apartmanima o&scaron;tete robu, djeca u igri ili kućni ljubimci)
          predviđeno je da zajedno sa fabrikama obezbijedimo najbolje
          rje&scaron;enje.
        </li>
      </ul>
      <!-- Comments are visible in the HTML source only -->
    </div>
    <div id="faqWrapper">
      <div>
        <h2><a name="cesta_pitanja"></a>FAQ - Česta pitanja</h2>
        <p>
          <b> - Pitanje:</b><br />
          Da li namještaj može da se plati po isporuci?<br />
          <b> - Odgovor:</b><br />
          Namještaj nije moguće platiti po isporuci. Po pravilniku firme mora
          biti uplaćen kompletan iznos sa predračuna da bi se obavila isporuka.
          <br /><br />

          <b> - Pitanje:</b><br />
          Da li Namos ima prodajnih mjesta u nekom drugom gradu mimo
          Podgorice?<br />
          <b> - Odgovor:</b><br />
          Nema, naš specijalizovani salon namještaja na 4200m2 se nalazi u
          Podgorici (Bulevar 21. maja 81). Ukoliko niste u
          mogućnosti da nas posjetite, moguće je telefonom poručiti namještaj
          koji možete pogledati na sajtu ili u flajerima i katalozima koji često
          izlaze uz dnevne novine Vijesti i Dan. Naravno prevoz i montaža su
          besplatni.<br /><br />

          <b> - Pitanje:</b><br />
          Da li Namos vrši isporuku namještaja na teritoriji Srbije?<br />
          <b> - Odgovor:</b><br />
          Za vrijeme trajanja "Beogradskog sajma namještaja" koji se održava
          svake godine početkom novembra isporučujemo robu i na teritoriji
          Srbije.<br /><br />
          <br /><br />
        </p>
      </div>

      <div class="kolona-slika">
        <div class="sticky-slika-wrap">
          <p>Besplatna dostava</p>
          <img
            src="https://namos.co.me/img/besplatan_transport.jpg"
            alt="Besplatna Dostava"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="scss">
// MOBILE =================================================================================================
@media only screen and (max-width: 600px) {
  #servisWrapper {
    position: relative;
    width: 100vw;
    padding: 5vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
  }

  #faqWrapper {
    width: 100%;
  }

  #tableWrapper {
    width: 100%;
  }

  #isporuka {
    font-family: Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
    font-size: 3vw;
    position: relative;
  }

  #isporuka tr:first-child {
    width: 10vw;
  }

  #isporuka td,
  #isporuka th {
    border: 1px solid #ddd;
    padding: 2vw;
  }

  #isporuka tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  #isporuka tr:hover {
    background-color: #ddd;
  }

  #isporuka th {
    padding-top: 2vw;
    padding-bottom: 2vw;
    text-align: center;
    background-color: #62a846;
    color: white;
    position: sticky;
    top: 0px;
  }
  #isporuka td {
    padding-top: 1vw;
    padding-bottom: 1vw;
    text-align: left;
  }

  #isporuka img {
    height: 4vw;
  }

  #pravilnikWrapper {
    width: 100%;
  }
}

// DESKTOP =================================================================================================

@media only screen and (min-width: 601px) {
  #servisWrapper {
    position: relative;
    width: 100vw;
    padding: 3vw;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }

  #faqWrapper {
    width: 20vw;
  }

  #tableWrapper {
    width: 30vw;
  }

  #isporuka {
    font-family: Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
    font-size: 1vw;
    position: relative;
  }

  #isporuka tr:first-child {
    width: 10vw;
  }

  #isporuka td,
  #isporuka th {
    border: 1px solid #ddd;
    padding: 8px;
  }

  #isporuka tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  #isporuka tr:hover {
    background-color: #ddd;
  }

  #isporuka th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #62a846;
    color: white;
    position: sticky;
    top: 0px;
  }
  #isporuka td {
    padding-top: 0.4vw;
    padding-bottom: 0.4vw;
    text-align: left;
  }

  #isporuka img {
    height: 1vw;
  }

  #pravilnikWrapper {
    width: 34vw;
  }

  /* Kontejner za sliku */
  .sticky-slika-wrap {
    position: -webkit-sticky; /* Podrška za Safari */
    position: sticky;

    /* OVO JE KLJUČNO: Pošto je Namos meni visok, 
       moramo spustiti tačku lepljenja da se ne bi preklopili */
    top: 180px;

    /* Osiguravamo da slika bude iznad ostalog sadržaja koji skroluje */
    z-index: 99;

    width: 80%;
    margin: 0 auto;
    text-align: center;
  }

  .sticky-slika-wrap img {
    width: 100%;
    height: auto;
    display: block;
  }
}
</style>
